import { render } from "./system-button.vue?vue&type=template&id=6b9df720&scoped=true"
import script from "./system-button.vue?vue&type=script&lang=js"
export * from "./system-button.vue?vue&type=script&lang=js"

import "./system-button.vue?vue&type=style&index=0&id=6b9df720&lang=scss&scoped=true"

import exportComponent from "/home/node/ks-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b9df720"]])

export default __exports__